export default [
  {
    path: '/',
    name: 'attendance',
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '@/pages/attendance/index')
  },
  {
    path: '/campus-attendance-teachers',
    name: 'campus-attendance-teacher',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/attendance/campus-attendance-teacher/index.vue')
  }
]
